"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ethers_eip712_1 = require("ethers-eip712");

var toHex_1 = __importDefault(require("./toHex"));

var hashTypedDataV3 = function hashTypedDataV3(msgParams) {
  return toHex_1.default(ethers_eip712_1.TypedDataUtils.encodeDigest(msgParams));
};

exports.default = hashTypedDataV3;